import { Game } from '../types';

interface Props {
  games: Game[];
}

const RANK_LABEL = ['Best Bet', 'Value', 'Spot Play'];

const PROB_COLOR = (p: number) =>
  p >= 20 ? '#15803D' : p >= 10 ? '#1535A0' : '#D42B2B';

function PickCard({ game, rank }: { game: Game; rank: number }) {
  const isTop = rank === 0;
  const pc = PROB_COLOR(game.prob);

  return (
    <div style={{
      flexShrink: 0,
      width: 155,
      background: isTop ? pc : '#0A1740',
      borderRadius: 14,
      padding: '14px 14px 12px',
      position: 'relative',
      overflow: 'hidden',
      cursor: 'pointer',
    }}>
      {/* decorative circle */}
      <div style={{
        position: 'absolute',
        bottom: -20, right: -20,
        width: 80, height: 80,
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.04)',
      }} />

      {/* rank label */}
      <div style={{
        fontSize: '0.58rem',
        fontWeight: 700,
        letterSpacing: 1.5,
        textTransform: 'uppercase',
        color: isTop ? 'rgba(255,255,255,0.65)' : 'rgba(255,255,255,0.4)',
        marginBottom: 8,
      }}>
        #{rank + 1} {RANK_LABEL[rank] ?? 'Pick'}
      </div>

      {/* probability */}
      <div style={{
        fontFamily: "'Bebas Neue', sans-serif",
        fontSize: '2.8rem',
        color: '#fff',
        lineHeight: 0.9,
        letterSpacing: -1,
      }}>
        {game.prob}
        <span style={{ fontSize: '1.2rem', opacity: 0.5 }}>%</span>
      </div>

      {/* matchup */}
      <div style={{
        fontSize: '0.78rem',
        fontWeight: 700,
        color: '#fff',
        letterSpacing: 0.3,
        marginTop: 8,
      }}>
        {game.awayAbbr} @ {game.homeAbbr}
      </div>

      {/* venue */}
      <div style={{
        fontSize: '0.62rem',
        color: 'rgba(255,255,255,0.45)',
        marginTop: 2,
      }}>
        {game.venue.split(' ').slice(0, 2).join(' ')}
      </div>

      {/* pitchers */}
      <div style={{
        fontSize: '0.62rem',
        color: 'rgba(255,255,255,0.45)',
        marginTop: 1,
      }}>
        {game.awayPitcher.split(' ')[1] ?? game.awayPitcher} vs{' '}
        {game.homePitcher.split(' ')[1] ?? game.homePitcher}
      </div>
    </div>
  );
}

export default function PicksScroll({ games }: Props) {
  const topPicks = games.filter((g: Game) => g.strong).slice(0, 3);

  if (topPicks.length === 0) return null;

  return (
    <div>
      <div style={{
        padding: '14px 20px 0',
        fontSize: '0.62rem',
        fontWeight: 700,
        letterSpacing: 2.5,
        textTransform: 'uppercase',
        color: '#8090B0',
      }}>
        Top Picks
      </div>
      <div style={{
        display: 'flex',
        gap: 10,
        padding: '10px 20px 14px',
        overflowX: 'auto',
      }}>
        {topPicks.map((g: Game, i: number) => (
          <PickCard key={g.id} game={g} rank={i} />
        ))}
      </div>
    </div>
  );
}
